import { IState } from '../../store';

export const getOffer = (state: IState) => {
  return state.offerData.offer;
};
